import {
  ArrowRight, Bell, BrainCircuit, Camera, Car, ChevronRight, Home,
  Lightbulb, Lock, Menu, Mic2, Moon, Rocket, Search, Settings2,
  ShieldCheck, Sparkles, Sun, UserRound, Users, Zap
} from "lucide-react";
import AION_WOMAN_HERO from "@/assets/aion-public/aion-woman-clean.webp";

const go = (path) => { window.location.href = path; };

const Header = () => (
  <header className="aion-public-header">
    <button className="aion-public-logo" onClick={() => go("/")} aria-label="AION Startseite">AION</button>
    <nav className="aion-public-desktop-nav" aria-label="AION Hauptnavigation">
      <button onClick={() => go("/")}>Start</button>
      <button onClick={() => go("/features")}>AION OS</button>
      <button onClick={() => go("/presence")}>Präsenz & Brain</button>
      <button onClick={() => go("/how-it-works")}>So funktioniert’s</button>
      <button className="aion-public-nav-login" onClick={() => go("/login")}>Anmelden</button>
    </nav>
    <details className="aion-public-menu-wrap">
      <summary className="aion-public-menu" aria-label="Menü"><Menu size={26} /></summary>
      <nav className="aion-public-menu-panel" aria-label="AION Navigation">
        <button onClick={() => go("/")}>Start</button>
        <button onClick={() => go("/features")}>Funktionen</button>
        <button onClick={() => go("/presence")}>Präsenz & Brain</button>
        <button onClick={() => go("/how-it-works")}>So funktioniert’s</button>
        <button onClick={() => go("/login")}>Anmelden</button>
      </nav>
    </details>
  </header>
);

const Feature = ({ icon: Icon, title, text, onClick }) => (
  <button className="aion-public-feature" onClick={onClick}>
    <span className="aion-public-icon"><Icon size={28} /></span>
    <span><strong>{title}</strong><small>{text}</small></span>
    <ChevronRight className="aion-public-chevron" size={22} />
  </button>
);

const StartPage = () => (
  <main className="aion-public-page aion-public-home aion-public-home-woman">
    <section className="aion-public-os-entry" aria-label="AION öffentliche Startseite">
      <div className="aion-public-os-topbar">
        <button className="aion-public-os-brand" onClick={() => go("/")} aria-label="AION Startseite">
          <strong>AION</strong><small>Your Life. Smarter.</small>
        </button>

        <button className="aion-public-os-voice" onClick={() => go("/how-it-works")}>
          <Mic2 size={20}/><span>Sag einfach, was du brauchst …</span>
        </button>

        <div className="aion-public-os-actions">
          <button className="aion-public-os-language" aria-label="Sprache"><span>◎</span> DE</button>
          <button className="aion-public-os-login" onClick={() => go("/login")}>Anmelden</button>
          <button className="aion-public-os-start" onClick={() => go("/register")}>Kostenlos starten</button>
        </div>
      </div>

      <div className="aion-public-os-layout">
        <aside className="aion-public-os-nav" aria-label="AION Bereiche">
          <button className="active" onClick={() => go("/")}><Home size={18}/> Home</button>
          <button onClick={() => go("/features")}><Home size={18}/> Räume</button>
          <button onClick={() => go("/features")}><Settings2 size={18}/> Geräte</button>
          <button onClick={() => go("/features")}><Zap size={18}/> Energie</button>
          <button onClick={() => go("/features")}><ShieldCheck size={18}/> Sicherheit</button>
          <button onClick={() => go("/features")}><Car size={18}/> Fahrzeuge</button>
          <button onClick={() => go("/features")}><Sun size={18}/> Wetter</button>
          <button onClick={() => go("/features")}><BrainCircuit size={18}/> KI Studio</button>
          <button onClick={() => go("/features")}><Sparkles size={18}/> Szenen</button>
          <button onClick={() => go("/features")}><Settings2 size={18}/> Automationen</button>
          <button onClick={() => go("/presence")}><Camera size={18}/> Kameras</button>
          <button onClick={() => go("/presence")}><Users size={18}/> Familie</button>

          <div className="aion-public-os-nav-card">
            <BrainCircuit size={28}/>
            <strong>AION OS</strong>
            <small>Für ein smarteres Leben. Heute.</small>
            <button onClick={() => go("/features")}>Mehr erfahren <ArrowRight size={14}/></button>
          </div>
        </aside>

        <div className="aion-public-os-content">
          <section className="aion-public-os-hero">
            <div className="aion-public-os-hero-copy">
              <p className="aion-public-kicker">WILLKOMMEN BEI</p>
              <h1><em>AION</em></h1>
              <h2>Dein Zuhause. Deine Familie. Deine Kontrolle.</h2>
              <p>Steuere dein Zuhause, behalte Energie und Sicherheit im Blick, verbinde deine Geräte und nutze AION Brain und Voice – alles in einer Oberfläche.</p>
              <div className="aion-public-os-hero-actions">
                <button className="aion-public-primary" onClick={() => go("/register")}>Jetzt kostenlos starten <ArrowRight size={18}/></button>
                <button className="aion-public-secondary" onClick={() => go("/how-it-works")}>So funktioniert AION</button>
              </div>
            </div>

            <div className="aion-public-os-house-scene" aria-hidden="true">
              <div className="aion-public-os-sky"/>
              <div className="aion-public-os-house">
                <i/><i/><i/><i/><i/><i/>
              </div>
              <div className="aion-public-os-pool"/>
              <div className="aion-public-os-city"/>
            </div>

            <aside className="aion-public-os-assistant">
              <img src={AION_WOMAN_HERO} alt="AION – intelligente Assistenz" loading="eager" fetchPriority="high" />
              <div>
                <span>AION ASSISTENT</span>
                <strong>Hallo!</strong>
                <p>Ich zeige dir, wie AION Zuhause, Geräte, Energie, Sicherheit und KI zusammenbringt.</p>
              </div>
              <button onClick={() => go("/features")}>Was kann AION? <ChevronRight size={17}/></button>
              <button onClick={() => go("/how-it-works")}>Zeig mir ein Beispiel <ChevronRight size={17}/></button>
            </aside>
          </section>

          <section className="aion-public-os-summary" aria-label="AION Module">
            <button onClick={() => go("/features")}><Home size={22}/><span><b>Räume</b><strong>10</strong><small>aktiv</small></span><ChevronRight/></button>
            <button onClick={() => go("/features")}><Settings2 size={22}/><span><b>Geräte</b><strong>24</strong><small>verbunden</small></span><ChevronRight/></button>
            <button onClick={() => go("/features")}><Zap size={22}/><span><b>Energie</b><strong>3.609 W</strong><small>aktuell</small></span><ChevronRight/></button>
            <button onClick={() => go("/features")}><ShieldCheck size={22}/><span><b>Sicherheit</b><strong>Alles sicher</strong><small>keine Probleme</small></span><ChevronRight/></button>
            <button onClick={() => go("/features")}><Car size={22}/><span><b>Fahrzeuge</b><strong>1</strong><small>verbunden</small></span><ChevronRight/></button>
            <button onClick={() => go("/features")}><Sun size={22}/><span><b>Wetter</b><strong>31.9°C</strong><small>Prishtina</small></span><ChevronRight/></button>
          </section>

          <section className="aion-public-os-capabilities">
            <article><Home/><strong>Smart Home</strong><p>Licht, Klima, Rollläden und Geräte zentral verwalten.</p><button onClick={() => go("/features")}>Entdecken <ChevronRight/></button></article>
            <article><Zap/><strong>Energie</strong><p>Verbrauch, Solar, Speicher und Kosten verstehen.</p><button onClick={() => go("/features")}>Entdecken <ChevronRight/></button></article>
            <article><ShieldCheck/><strong>Sicherheit</strong><p>Kameras, Sensoren, Türen und Status im Blick behalten.</p><button onClick={() => go("/features")}>Entdecken <ChevronRight/></button></article>
            <article><BrainCircuit/><strong>KI Studio</strong><p>AION Brain, Voice, Wissen und Projekte zusammen nutzen.</p><button onClick={() => go("/features")}>Entdecken <ChevronRight/></button></article>
            <article><Settings2/><strong>Automationen</strong><p>Szenen, Zeitpläne und intelligente Abläufe verbinden.</p><button onClick={() => go("/features")}>Entdecken <ChevronRight/></button></article>
            <article><Users/><strong>Familie</strong><p>Profile, Präsenz und persönliche Bereiche organisieren.</p><button onClick={() => go("/presence")}>Entdecken <ChevronRight/></button></article>
          </section>

          <section className="aion-public-os-live-grid">
            <article className="aion-public-os-room-preview">
              <div className="aion-public-os-panel-title"><Home size={18}/><strong>Live Vorschau · Wohnzimmer</strong><span><i/> Live</span></div>
              <div className="aion-public-os-room-visual">
                <div className="aion-public-os-room-window"/>
                <div className="aion-public-os-room-sofa"/>
                <div className="aion-public-os-room-light"/>
              </div>
              <div className="aion-public-os-room-actions"><span><Lightbulb/> Licht</span><span>▣ TV</span><span>❄ Klima</span><span>▤ Rollläden</span></div>
            </article>

            <article className="aion-public-os-energy-preview">
              <div className="aion-public-os-panel-title"><Zap size={18}/><strong>Aktueller Energiefluss</strong><span>Heute</span></div>
              <div className="aion-public-os-energy-flow">
                <span className="solar"><Sun/> Solar <b>52 W</b></span>
                <span className="home"><Home/> Haus <b>2.341 W</b></span>
                <span className="battery">▣ Batterie <b>81%</b></span>
                <span className="grid">⌁ Netz <b>1.268 W</b></span>
              </div>
            </article>

            <article className="aion-public-os-weather-preview">
              <div className="aion-public-os-panel-title"><Sun size={18}/><strong>Wetter · Prishtina</strong></div>
              <div className="aion-public-os-weather-main"><Sun/><strong>31.9°C</strong><small>Klarer Himmel</small></div>
              <div className="aion-public-os-weather-row"><span>0% Regen</span><span>56% Luftfeuchtigkeit</span><span>6.5 km/h Wind</span></div>
            </article>
          </section>
        </div>
      </div>
    </section>

    <section className="aion-product-story" aria-label="AION Produktbereiche">
      <article className="aion-story-panel aion-story-rooms">
        <div className="aion-story-copy">
          <p className="aion-public-kicker">RÄUME & GERÄTE</p>
          <h2>Dein Zuhause auf einen Blick.</h2>
          <p>Jeder Raum bekommt seinen eigenen intelligenten Kontext: Temperatur, Licht, Luftqualität, Geräte, Kameras, Szenen und Automationen.</p>
          <div className="aion-story-tags"><span>Wohnzimmer</span><span>Küche</span><span>Schlafzimmer</span><span>Garten</span></div>
        </div>
        <div className="aion-room-preview" aria-label="Beispiel Raumübersicht">
          <div className="aion-room-card active"><b>Wohnzimmer</b><strong>22.0°</strong><small>4 Geräte aktiv</small></div>
          <div className="aion-room-card"><b>Küche</b><strong>21.5°</strong><small>3 Geräte aktiv</small></div>
          <div className="aion-room-card"><b>Schlafzimmer</b><strong>19.0°</strong><small>Nachtmodus</small></div>
          <div className="aion-room-card"><b>Garten</b><strong>24.0°</strong><small>Automationen aktiv</small></div>
        </div>
      </article>

      <article className="aion-story-panel aion-story-energy">
        <div className="aion-story-copy">
          <p className="aion-public-kicker">ENERGIE</p>
          <h2>Verstehen, wo deine Energie fließt.</h2>
          <p>AION kann Verbrauch, Produktion, Speicher und große Verbraucher in einer gemeinsamen Energieansicht zusammenführen.</p>
          <div className="aion-energy-summary"><span><b>3.609 W</b> Verbrauch</span><span><b>52 W</b> Produktion</span><span><b>81%</b> Speicher</span></div>
        </div>
        <div className="aion-energy-preview" aria-label="Beispiel Energiefluss">
          <div className="energy-node solar">Solar<small>52 W</small></div>
          <div className="energy-line"/>
          <div className="energy-node home">Zuhause<small>2.341 W</small></div>
          <div className="energy-line"/>
          <div className="energy-node battery">Batterie<small>81 %</small></div>
          <div className="aion-energy-bars" aria-hidden="true">{[28,42,36,58,72,64,88,76,52,68,46,32].map((height,index)=><i key={index} style={{height:`${height}%`}}/>)}</div>
        </div>
      </article>

      <article className="aion-story-panel aion-story-security">
        <div className="aion-security-preview">
          <ShieldCheck size={58}/>
          <strong>Alles sicher</strong>
          <small>Beispielansicht · Status auf einen Blick</small>
          <div><span>Türen</span><b>geschlossen</b></div>
          <div><span>Kameras</span><b>bereit</b></div>
          <div><span>Bewegung</span><b>keine Aktivität</b></div>
        </div>
        <div className="aion-story-copy">
          <p className="aion-public-kicker">SICHERHEIT & PRÄSENZ</p>
          <h2>AION behält den Kontext im Blick.</h2>
          <p>Präsenz, Türen, Sensoren und Kamerastatus können gemeinsam bewertet werden. Kritische Aktionen bleiben dabei an Rollen, Policies und Bestätigungen gebunden.</p>
          <div className="aion-story-tags"><span>Trusted Actions</span><span>Rollen</span><span>Bestätigung</span></div>
        </div>
      </article>

      <article className="aion-story-panel aion-story-brain">
        <div className="aion-story-copy">
          <p className="aion-public-kicker">BRAIN + VOICE</p>
          <h2>Sprechen. Verstehen. Sicher handeln.</h2>
          <p>AION verbindet natürliche Sprache mit Kontext, Memory und den passenden Funktionen – statt nur eine Textantwort zurückzugeben.</p>
          <div className="aion-brain-flow">
            <span><Mic2 size={18}/> Stimme</span><i>→</i><span><BrainCircuit size={18}/> Brain</span><i>→</i><span><ShieldCheck size={18}/> Policy</span><i>→</i><span><Zap size={18}/> Aktion</span>
          </div>
        </div>
        <div className="aion-voice-preview">
          <div className="voice-wave" aria-hidden="true">{[20,46,70,38,82,55,92,44,68,30,58,24].map((height,index)=><i key={index} style={{height:`${height}%`}}/>)}</div>
          <p>„AION, mach das Wohnzimmer gemütlich.“</p>
          <small>Kontext erkannt · Szene vorbereitet · Sicherheitsregeln geprüft</small>
        </div>
      </article>
    </section>

    <section className="aion-home-intro aion-home-intro-woman">
      <p className="aion-public-kicker">MEHR ALS KI</p>
      <h2>Eine intelligente Präsenz.<br/><em>Für deinen Alltag.</em></h2>
      <p>AION verbindet dein Zuhause, deine Stimme und dein Wissen. Es hilft dir, Dinge einfacher zu steuern, Zusammenhänge zu verstehen und deinen Alltag besser zu organisieren.</p>
    </section>

    <section className="aion-home-feature-grid aion-home-feature-grid-woman">
      <Feature icon={Home} title="Home" text="Geräte, Räume und Routinen zentral verbinden und steuern." onClick={() => go("/features")} />
      <Feature icon={Mic2} title="Voice" text="Natürlich sprechen und AION direkt um Unterstützung bitten." onClick={() => go("/features")} />
      <Feature icon={UserRound} title="Präsenz" text="Kontext erkennen und Informationen passend zur Situation anzeigen." onClick={() => go("/presence")} />
      <Feature icon={BrainCircuit} title="AION Brain" text="Wissen, Erinnerungen und Zusammenhänge intelligent vernetzen." onClick={() => go("/presence")} />
    </section>

    <section className="aion-home-showcase">
      <div className="aion-home-showcase-head">
        <p className="aion-public-kicker">AION IN AKTION</p>
        <h2>So fühlt sich AION im Alltag an.</h2>
        <p>Ein paar Beispiele zeigen sofort, wie Sprache, Brain, Präsenz und dein Zuhause zusammenarbeiten.</p>
      </div>

      <div className="aion-home-showcase-grid">
        <article className="aion-demo-card aion-demo-voice">
          <div className="aion-demo-top"><span className="aion-public-icon"><Mic2 size={26}/></span><strong>Voice</strong></div>
          <div className="aion-demo-chat user">„AION, Licht im Wohnzimmer an.“</div>
          <div className="aion-demo-chat system">Wohnzimmer erkannt · Licht wird gesteuert.</div>
          <small>Sprache verstehen und an die richtige AION-Funktion weitergeben.</small>
        </article>

        <article className="aion-demo-card aion-demo-brain">
          <div className="aion-demo-top"><span className="aion-public-icon"><BrainCircuit size={26}/></span><strong>AION Brain</strong></div>
          <div className="aion-demo-chat user">„Was weißt du über Projekt X?“</div>
          <div className="aion-demo-chat system">Relevante Erinnerungen, Themen und Zusammenhänge werden verknüpft.</div>
          <small>Bestehendes Wissen aus AION Memory als Kontext nutzen.</small>
        </article>

        <article className="aion-demo-card aion-demo-presence">
          <div className="aion-demo-top"><span className="aion-public-icon"><UserRound size={26}/></span><strong>Präsenz</strong></div>
          <div className="aion-presence-demo-row"><Home size={18}/><span>Zuhause</span><b>aktiv</b></div>
          <div className="aion-presence-demo-row"><Moon size={18}/><span>Ruhemodus</span><b>bereit</b></div>
          <div className="aion-presence-demo-row"><Car size={18}/><span>Unterwegs</span><b>erkannt</b></div>
          <small>Informationen und Abläufe passend zur Situation anzeigen.</small>
        </article>
      </div>
    </section>

    <section className="aion-home-capabilities">
      <div className="aion-home-capabilities-head">
        <p className="aion-public-kicker">WAS AION VERBINDET</p>
        <h2>Ein System. Mehrere intelligente Bereiche.</h2>
      </div>
      <div className="aion-home-capability-grid">
        <div><Mic2/><strong>Voice</strong><span>Sprechen & verstehen</span></div>
        <div><BrainCircuit/><strong>Brain</strong><span>Wissen & Memory</span></div>
        <div><UserRound/><strong>Präsenz</strong><span>Kontext & Situationen</span></div>
        <div><Home/><strong>Smart Home</strong><span>Räume & Geräte</span></div>
        <div><Settings2/><strong>Automationen</strong><span>Routinen & Abläufe</span></div>
        <div><ShieldCheck/><strong>Sicherheit</strong><span>Rollen & Kontrolle</span></div>
      </div>
    </section>

    <section className="aion-home-bottom-cta">
      <div>
        <p className="aion-public-kicker">EINE PLATTFORM. VIELE MÖGLICHKEITEN.</p>
        <h2>Entdecke, was AION für dich tun kann.</h2>
      </div>
      <button className="aion-public-primary" onClick={() => go("/features")}>Funktionen ansehen <ArrowRight size={20}/></button>
    </section>
  </main>
);

const FeaturesPage = () => (
  <main className="aion-public-page">
    <Header />
    <section className="aion-public-heading-card">
      <p className="aion-public-kicker">FUNKTIONEN</p>
      <h1>Was <em>AION</em> kann</h1>
      <h2>Eine Plattform. Viele Möglichkeiten.</h2>
      <p>AION vereint alle wichtigen Funktionen in einer intelligenten Oberfläche – für ein einfacheres, sichereres und vernetztes Zuhause.</p>
    </section>
    <section className="aion-os-module-strip" aria-label="AION OS Module">
      <div><Home/><span><strong>Räume</strong><small>Klima · Licht · Medien</small></span></div>
      <div><Settings2/><span><strong>Geräte</strong><small>Verbinden · Steuern</small></span></div>
      <div><Zap/><span><strong>Energie</strong><small>Verbrauch · Produktion</small></span></div>
      <div><ShieldCheck/><span><strong>Sicherheit</strong><small>Status · Schutz</small></span></div>
      <div><BrainCircuit/><span><strong>KI Studio</strong><small>Brain · Wissen · Voice</small></span></div>
      <div><UserRound/><span><strong>Präsenz</strong><small>Familie · Kontext</small></span></div>
    </section>

    <section className="aion-public-grid">
      <Feature icon={BrainCircuit} title="AION Brain" text="Dein Wissen. Immer verfügbar." onClick={() => go("/presence")} />
      <Feature icon={Mic2} title="Voice Assistant" text="Natürlich sprechen. Direkt umsetzen." />
      <Feature icon={UserRound} title="Präsenz" text="Immer da. Wenn es zählt." onClick={() => go("/presence")} />
      <Feature icon={Home} title="Smart Home" text="Alle Geräte. Eine Steuerung." />
      <Feature icon={Settings2} title="Automationen" text="Routinen, die mitdenken." />
      <Feature icon={ShieldCheck} title="Sicherheit" text="Deine Daten. Maximal geschützt." />
    </section>
    <section className="aion-feature-os" aria-label="AION OS Bereiche">
      <div className="aion-feature-os-head">
        <p className="aion-public-kicker">AION OS IM ALLTAG</p>
        <h2>Ein System. <em>Sechs starke Ebenen.</em></h2>
        <p>Vom AION Brain bis zur physischen Welt: Räume, Energie, Sicherheit, Voice, Automationen und Edge-Geräte arbeiten über gemeinsame Berechtigungen und Trusted Actions zusammen.</p>
      </div>

      <div className="aion-feature-os-grid">
        <article className="aion-feature-panel home">
          <div className="aion-feature-panel-title"><Home size={24}/><div><strong>Smart Home & Räume</strong><small>Alles an einem Ort</small></div></div>
          <div className="aion-feature-room-row"><span>Wohnzimmer</span><b>22.0°</b><i>4 Geräte</i></div>
          <div className="aion-feature-room-row"><span>Küche</span><b>21.5°</b><i>3 Geräte</i></div>
          <div className="aion-feature-room-row"><span>Schlafzimmer</span><b>19.0°</b><i>Nachtmodus</i></div>
          <p>Räume, Licht, Klima, Medien und Sensoren in einer gemeinsamen Ansicht.</p>
        </article>

        <article className="aion-feature-panel energy">
          <div className="aion-feature-panel-title"><Zap size={24}/><div><strong>Energie</strong><small>Verbrauch verstehen</small></div></div>
          <div className="aion-feature-energy-number">3.609 <span>W</span></div>
          <div className="aion-feature-bars"><i style={{height:"35%"}}/><i style={{height:"58%"}}/><i style={{height:"46%"}}/><i style={{height:"82%"}}/><i style={{height:"65%"}}/><i style={{height:"92%"}}/><i style={{height:"56%"}}/></div>
          <div className="aion-feature-status-line"><span>Heute</span><b>↓ 12 %</b></div>
          <p>Verbrauch, Produktion und Gerätewerte verständlich zusammenführen.</p>
        </article>

        <article className="aion-feature-panel security">
          <div className="aion-feature-panel-title"><ShieldCheck size={24}/><div><strong>Sicherheit</strong><small>Status auf einen Blick</small></div></div>
          <div className="aion-feature-safe"><ShieldCheck size={38}/><strong>Alles sicher</strong><small>Keine Auffälligkeiten</small></div>
          <div className="aion-feature-security-grid"><span>Türen <b>zu</b></span><span>Fenster <b>zu</b></span><span>Bewegung <b>ruhig</b></span><span>Kameras <b>online</b></span></div>
          <p>Geräte- und Sicherheitszustände sichtbar machen, ohne kritische Aktionen ungeprüft auszuführen.</p>
        </article>

        <article className="aion-feature-panel brain">
          <div className="aion-feature-panel-title"><BrainCircuit size={24}/><div><strong>Brain & Voice</strong><small>Eine intelligente Ebene</small></div></div>
          <div className="aion-feature-voice"><Mic2 size={20}/><span>„AION, was ist gerade wichtig?“</span></div>
          <div className="aion-feature-brain-flow"><span>Voice</span><ChevronRight/><span>Kontext</span><ChevronRight/><span>Brain</span><ChevronRight/><span>Aktion</span></div>
          <p>AION verbindet Sprache, Wissen und Kontext mit den richtigen Funktionen und Sicherheitsgrenzen.</p>
        </article>

        <article className="aion-feature-panel devices">
          <div className="aion-feature-panel-title"><Settings2 size={24}/><div><strong>Geräte & Sensoren</strong><small>Alles verbunden</small></div></div>
          <div className="aion-feature-device-grid">
            <span><b>TV</b><small>Online</small></span>
            <span><b>Klima</b><small>22° Auto</small></span>
            <span><b>Licht</b><small>65 %</small></span>
            <span><b>Kamera</b><small>Bereit</small></span>
          </div>
          <p>Geräte, Sensoren und lokale Hardware werden in AION als gemeinsame, kontrollierbare Fähigkeiten sichtbar.</p>
        </article>

        <article className="aion-feature-panel studio">
          <div className="aion-feature-panel-title"><Sparkles size={24}/><div><strong>KI Studio</strong><small>Ideen werden Ergebnisse</small></div></div>
          <div className="aion-feature-studio">
            <span>Chat</span><span>Voice</span><span>Wissen</span><span>Projekte</span>
          </div>
          <div className="aion-feature-voice"><BrainCircuit size={20}/><span>Eine KI-Ebene für Alltag, Wissen und kreative Aufgaben.</span></div>
          <p>AION Brain, Voice und deine verbundenen Bereiche arbeiten in einer gemeinsamen Oberfläche zusammen.</p>
        </article>

        <article className="aion-feature-panel automation">
          <div className="aion-feature-panel-title"><Settings2 size={24}/><div><strong>Szenen & Automationen</strong><small>Routinen, die mitdenken</small></div></div>
          <div className="aion-feature-automation-list">
            <span><i className="on"/> Licht bei Bewegung <b>AKTIV</b></span>
            <span><i className="on"/> Rollläden bei Sonnenuntergang <b>AKTIV</b></span>
            <span><i className="on"/> Gute Nacht <b>AKTIV</b></span>
            <span><i/> Heizung nach Zeitplan <b>PAUSE</b></span>
          </div>
          <p>AION kombiniert Zeit, Präsenz, Sensoren und Szenen – kritische Aktionen bleiben durch Berechtigungen geschützt.</p>
        </article>

        <article className="aion-feature-panel physical">
          <div className="aion-feature-panel-title"><Zap size={24}/><div><strong>Physical & Edge Hub</strong><small>Die Brücke zur realen Welt</small></div></div>
          <div className="aion-feature-edge-flow">
            <span><Mic2 size={16}/> Voice</span><ChevronRight/><span><BrainCircuit size={16}/> Brain</span><ChevronRight/><span><ShieldCheck size={16}/> Trusted Action</span>
          </div>
          <div className="aion-feature-edge-devices">
            <span>Sensoren <b>READ</b></span>
            <span>GPIO / Relay <b>SAFE</b></span>
            <span>Robotik <b>READ ONLY</b></span>
            <span>Edge Hub <b>READY</b></span>
          </div>
          <p>Vorbereitet für Raspberry Pi, Sensoren und physische Geräte. Reale Ausführung wird erst nach dediziertem Adapter und Sicherheitsprüfung freigegeben.</p>
        </article>
      </div>
    </section>

    <section className="aion-os-architecture" aria-label="AION OS Systemarchitektur">
      <div className="aion-os-architecture-head">
        <p className="aion-public-kicker">SO ARBEITET AION ZUSAMMEN</p>
        <h2>Von deiner Stimme bis zur <em>sicheren Aktion.</em></h2>
        <p>AION verbindet Eingaben, Kontext, Brain, Berechtigungen und Geräte in einem kontrollierten Ablauf – statt einzelne Funktionen isoliert nebeneinanderzustellen.</p>
      </div>

      <div className="aion-os-architecture-flow">
        <article className="aion-os-layer input">
          <span className="aion-os-layer-icon"><Mic2 size={24}/></span>
          <div><b>Voice & Sensoren</b><small>Sprache · App · Präsenz · Kamerastatus</small></div>
        </article>
        <ChevronRight className="aion-os-flow-arrow"/>
        <article className="aion-os-layer brain">
          <span className="aion-os-layer-icon"><BrainCircuit size={24}/></span>
          <div><b>AION Brain</b><small>Intent · Kontext · Memory · Wissen</small></div>
        </article>
        <ChevronRight className="aion-os-flow-arrow"/>
        <article className="aion-os-layer policy">
          <span className="aion-os-layer-icon"><ShieldCheck size={24}/></span>
          <div><b>Trusted Actions</b><small>Rollen · Regeln · Bestätigung · Audit</small></div>
        </article>
        <ChevronRight className="aion-os-flow-arrow"/>
        <article className="aion-os-layer action">
          <span className="aion-os-layer-icon"><Zap size={24}/></span>
          <div><b>Ausführung</b><small>Räume · Energie · Automation · Edge</small></div>
        </article>
      </div>

      <div className="aion-os-safety-bar">
        <Lock size={19}/>
        <span><strong>Kritische Aktionen bleiben kontrolliert.</strong> Physische oder sicherheitsrelevante Aktionen werden nicht blind ausgeführt.</span>
      </div>
    </section>

    <section className="aion-public-info-card">
      <div>
        <p className="aion-public-kicker">INTELLIGENTER ZUSAMMEN</p>
        <h2>Mehr als ein Assistent</h2>
        <p>AION ist ein System, das versteht, denkt und reagiert – und dabei deine Geräte, Räume und Informationen miteinander verbindet.</p>
      </div>
      <div className="aion-orbit" aria-hidden="true"><span>AION</span><Home/><Zap/><ShieldCheck/><UserRound/></div>
    </section>
    <section className="aion-public-cta aion-os-final-cta">
      <p className="aion-public-kicker">DEIN AION OS</p>
      <h2>Bereit, <em>AION selbst zu erleben?</em></h2>
      <p>Starte mit deinem Konto. Räume, Geräte, Energie, Sicherheit, Voice und Automationen wachsen danach mit deinem AION Setup.</p>
      <div className="aion-public-actions">
        <button className="aion-public-primary" onClick={() => go("/register")}>AION starten <ArrowRight size={20}/></button>
        <button className="aion-public-secondary" onClick={() => go("/how-it-works")}>So funktioniert AION</button>
      </div>
    </section>
  </main>
);

const PresencePage = () => (
  <main className="aion-public-page">
    <Header />
    <section className="aion-public-hero aion-presence-hero">
      <div>
        <p className="aion-public-kicker">INTELLIGENTER ALLTAG</p>
        <h1><em>AION</em> versteht, was gerade wichtig ist.</h1>
        <p className="aion-public-lead">AION erkennt Kontext, Räume und Situationen – und unterstützt dich proaktiv, genau dann, wenn es wirklich zählt.</p>
      </div>
      <div className="aion-presence-house" aria-hidden="true">
        <span><Moon/> Ruhemodus</span><span><Home/> Zuhause</span><span><Car/> Unterwegs</span>
      </div>
    </section>
    <section className="aion-public-info-card vertical">
      <h2>Deine Präsenz. Intelligenter genutzt.</h2>
      <p>AION erkennt automatisch, wo du bist und was du gerade tust.</p>
      <Feature icon={Home} title="Zuhause" text="Passt Licht, Temperatur und Geräte automatisch an." />
      <Feature icon={Car} title="Unterwegs" text="Sorgt für Sicherheit, spart Energie und behält dein Zuhause im Blick." />
      <Feature icon={Moon} title="Ruhemodus" text="Schafft eine entspannte, störungsfreie Umgebung." />
    </section>
    <section className="aion-public-brain-card">
      <div>
        <span className="aion-public-icon"><BrainCircuit size={30}/></span>
        <h2>AION Brain</h2>
        <p>AION verknüpft Wissen, Erinnerungen und Zusammenhänge. So versteht AION deine Gewohnheiten und kann bessere Entscheidungen vorbereiten.</p>
        <div className="aion-brain-tags"><span>Wissen</span><span>Erinnerungen</span><span>Zusammenhänge</span></div>
      </div>
      <div className="brain-orb" aria-hidden="true"><BrainCircuit size={64}/></div>
    </section>
    <button className="aion-public-primary full" onClick={() => go("/how-it-works")}>Mehr über Präsenz erfahren <ArrowRight size={20}/></button>
  </main>
);

const HowPage = () => (
  <main className="aion-public-page">
    <Header />
    <section className="aion-public-heading-card plain">
      <p className="aion-public-kicker">EINFACH. SICHER. INTELLIGENT.</p>
      <h1>So funktioniert <em>AION</em></h1>
      <p>In nur wenigen Schritten zu deinem intelligenten Zuhause. Einfach einrichten, sicher nutzen und mehr aus deinem Alltag machen.</p>
    </section>
    <section className="aion-public-steps">
      <div><b>1</b><span className="aion-public-icon"><UserRound/></span><span><strong>Registrieren</strong><small>Konto erstellen und E-Mail bestätigen.</small></span></div>
      <div><b>2</b><span className="aion-public-icon"><Settings2/></span><span><strong>Einrichten</strong><small>Geräte verbinden und persönliche Einstellungen vornehmen.</small></span></div>
      <div><b>3</b><span className="aion-public-icon"><Rocket/></span><span><strong>Loslegen</strong><small>Mit AION sprechen, steuern und automatisieren.</small></span></div>
    </section>
    <section className="aion-how-system" aria-label="AION Systemablauf">
      <div className="aion-how-system-head">
        <p className="aion-public-kicker">WAS IM HINTERGRUND PASSIERT</p>
        <h2>Von deiner Stimme bis zur <em>sicheren Aktion.</em></h2>
        <p>AION verbindet Sprache, Brain, Kontext und deine Geräte. Kritische Aktionen laufen dabei nicht direkt vom KI-Modell zur Hardware, sondern durch definierte Sicherheitsgrenzen.</p>
      </div>

      <div className="aion-how-pipeline">
        <article><span><Mic2/></span><b>1</b><strong>Voice</strong><small>Deine Anfrage wird aufgenommen und als Sprache verstanden.</small></article>
        <i><ChevronRight/></i>
        <article><span><BrainCircuit/></span><b>2</b><strong>AION Brain</strong><small>Absicht, Wissen und relevante Zusammenhänge werden verarbeitet.</small></article>
        <i><ChevronRight/></i>
        <article><span><UserRound/></span><b>3</b><strong>Kontext</strong><small>Raum, Präsenz, Zustand und verfügbare Fähigkeiten werden berücksichtigt.</small></article>
        <i><ChevronRight/></i>
        <article><span><ShieldCheck/></span><b>4</b><strong>Policy</strong><small>Rollen, Berechtigungen und nötige Bestätigungen werden geprüft.</small></article>
        <i><ChevronRight/></i>
        <article><span><Zap/></span><b>5</b><strong>Aktion</strong><small>Geräte, Szenen, Automationen oder sichere Edge-Funktionen werden ausgeführt.</small></article>
        <i><ChevronRight/></i>
        <article><span><Sparkles/></span><b>6</b><strong>Feedback</strong><small>Status und Ergebnis fließen zurück zu AION und werden verständlich angezeigt.</small></article>
      </div>

      <div className="aion-how-example">
        <div className="aion-how-example-command"><Mic2/><span>„AION, mach das Wohnzimmer gemütlich.“</span></div>
        <div className="aion-how-example-result">
          <span>Wohnzimmer erkannt</span><ChevronRight/>
          <span>Szene vorbereitet</span><ChevronRight/>
          <span>Policy geprüft</span><ChevronRight/>
          <strong>Ausführung bereit</strong>
        </div>
      </div>
    </section>

    <section className="aion-public-benefits">
      <div><ShieldCheck/><strong>Sicher</strong><small>Trusted Actions und Bestätigungen schützen kritische Aktionen.</small></div>
      <div><Lock/><strong>Privat</strong><small>Du behältst die Kontrolle über Konten, Rollen und verbundene Bereiche.</small></div>
      <div><Zap/><strong>Einfach</strong><small>Sprache, Geräte und Automationen arbeiten in einer gemeinsamen Oberfläche.</small></div>
    </section>
    <section className="aion-public-cta final">
      <Sparkles className="aion-cta-spark"/>
      <h2>Bereit für eine <em>intelligentere Zukunft?</em></h2>
      <p>Werde Teil von AION und erlebe, wie einfach ein intelligentes Zuhause sein kann.</p>
      <div className="aion-public-actions">
        <button className="aion-public-primary" onClick={() => go("/register")}>Jetzt registrieren <ArrowRight size={20}/></button>
        <button className="aion-public-link" onClick={() => go("/login")}>Anmelden</button>
      </div>
    </section>
  </main>
);

export const PublicLanding = ({ page = "start" }) => {
  if (page === "features") return <FeaturesPage />;
  if (page === "presence") return <PresencePage />;
  if (page === "how") return <HowPage />;
  return <StartPage />;
};
